import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { ROUTES } from "@/routes";
import { isFirmTabKind } from "@/api/profiles/firmTabsService";
import { FirmTabForm } from "./FirmTabForm";

export function FirmTabNew() {
  const { kind } = useParams<{ kind: string }>();
  const [searchParams] = useSearchParams();
  if (!isFirmTabKind(kind)) {
    return <Navigate to={ROUTES.profiles.firmTabs} replace />;
  }
  // Allow deep-linking from FirmDetail with `?companyId=…`
  const initialCompanyId = searchParams.get("companyId");
  return <FirmTabForm kind={kind} mode="new" initialCompanyId={initialCompanyId} />;
}

export default FirmTabNew;
